import PropTypes from 'prop-types';
import { ptBR } from 'date-fns/locale';
// @mui
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { ptBR as pickersPtBR } from '@mui/x-date-pickers/locales';

// Sem adapterLocale, o adapter do date-fns assume en-US (relógio AM/PM, mês só sai em
// português se outro módulo chamou setDefaultOptions antes) e, sem localeText, a barra do
// calendário fica no inglês do MUI. Os formulários do painel são em português e 24 h.
const { localeText } = pickersPtBR.components.MuiLocalizationProvider.defaultProps;

PickersLocalizationProvider.propTypes = {
  children: PropTypes.node,
};

export default function PickersLocalizationProvider({ children }) {
  return (
    <LocalizationProvider dateAdapter={AdapterDateFns} adapterLocale={ptBR} localeText={localeText}>
      {children}
    </LocalizationProvider>
  );
}
